<template>
    <aside v-if="!hide" id="cookies-advise" class="rounded text-center p-6">
        
        <span class="icon-cookies text-green-light"></span>
        
        <h5 class="text-white font-weight-bold pt-5 mb-4">
            {{ __( 'cookies.title' ) }}
        </h5>

        <p class="text-white">
            {{ __( 'cookies.resume' ) }}
        </p>
        
        <a v-if="href" :href="href" class="d-block text-green mb-4">
            {{ __( 'cookies.More-info' ) }} ->
        </a>

        <button class="btn btn-slide btn-outline-secondary" @click="accept">
            {{ __( 'cookies.Accept' ) }}
        </button>

    </aside>
</template>

<script>
    export default {
        props: {
            href: String,
        },

        data: function () {
            return {
                hide: true,
            }
        },

        mounted: function () {

            if ( Cookies.enabled && Cookies.get( 'cookies-accepted' ) ) {
                this.hide = true;
            } else {
                var inview = new Waypoint.Inview ( {
                    element: $( '#introduction' ),
                    exited: ( direction ) => {
                        this.accept();
                    }
                } );
                this.hide = false;
            }
        },

        methods: {
            accept: function () {
                this.hide = true;

                if ( Cookies.enabled ) {
                    Cookies.set( 'cookies-accepted', 'true' );
                }
            },
        },
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #cookies-advise {
        position: fixed;
        right: 1.5rem;
        top: 20%;
        width: 20rem;

        background-color: rgba( 0, 0, 0, .6 );

        .icon-cookies {
            font-size: 3.5rem;
        }

        &:before {
            content: '';
            position: absolute;
            right: 0;
            top: 33%;
            transform: translate3d( 100%, 0, 0 );

            width: 0;
            height: 0;
            border-style: solid;
            border-width: 1rem 0 1rem 1rem;
            border-color: transparent transparent transparent rgba( 0, 0, 0, .6);
        }

        @media (max-width: 767px) {
            background-color: rgba( 0, 0, 0, .9 );
            top: 15%;
            width: 16rem;

            p {
                font-size: .8rem;
            }

            &:before {
                border-color: transparent transparent transparent rgba( 0, 0, 0, .9 );
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/CookiesAdvise.vue